import { func, number } from 'prop-types'
import { useMemo } from 'react'
import styled from 'styled-components'
import { TextStyle } from '../Ui-Kits/Text'
import { faAngleRight, faAngleLeft } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { range } from 'lodash'

export const Pagination = ({ total, perPage, currentPage, onPageChange }) => {
  const totalPages = useMemo(() => Math.ceil(total / perPage), [total, perPage])
  const visiblePages = useMemo(() => {
    const pages = range(currentPage - 1, currentPage + 2).filter(page => page > 0 && page <= totalPages)

    if (pages.length < 3 && currentPage === 1 && totalPages >= 3) {
      return [...pages, 3]
    }

    if (pages.length < 3 && currentPage === totalPages && totalPages >= 3) {
      return [pages[0] - 1, ...pages]
    }

    return pages
  }, [currentPage, totalPages])

  return (
    <PaginationWrap>
      <Page onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}>
        <FontAwesomeIcon icon={faAngleLeft} />
      </Page>
      {visiblePages[0] !== 1 && (
        <>
          <Page onClick={() => onPageChange(1)}>{1}</Page>
          {visiblePages[0] !== 2 && <Page>...</Page>}
        </>
      )}
      {visiblePages.map(page => (
        <Page key={page} bold={currentPage === page} onClick={() => onPageChange(page)}>
          {page}
        </Page>
      ))}
      {visiblePages[visiblePages.length - 1] !== totalPages && (
        <>
          {visiblePages[visiblePages.length - 1] !== totalPages - 1 && <Page>...</Page>}
          <Page onClick={() => onPageChange(totalPages)}>{totalPages}</Page>
        </>
      )}
      <Page onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}>
        <FontAwesomeIcon icon={faAngleRight} />
      </Page>
    </PaginationWrap>
  )
}

Pagination.propTypes = {
  total: number.isRequired,
  currentPage: number.isRequired,
  perPage: number.isRequired,
  onPageChange: func.isRequired,
}

const PaginationWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.375rem;
  margin-top: 2rem;
`
const Page = styled.button`
  ${TextStyle}
  background-color: var(--color-transparent);
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
  border: 0;
  font-size: 1rem;
  color: var(--color-primary);
`
